import type { Component } from "solid-js";
import type { IconProps } from "./types";

const NavigateIcon: Component<IconProps> = (props = {}) => {
  const size = props.size || 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path d="M256 48A208.23 208.23 0 0 0 48 256c0 114.68 93.31 208 208 208a208.23 208.23 0 0 0 208-208c0-114.69-93.31-208-208-208Zm-8 361V264H103l259-114.11Z" />
    </svg>
  );
};

export default NavigateIcon;
